import { render, staticRenderFns } from "./DealerTerms.vue?vue&type=template&id=64a6af88&scoped=true&"
import script from "./DealerTerms.vue?vue&type=script&lang=js&"
export * from "./DealerTerms.vue?vue&type=script&lang=js&"
import style0 from "./DealerTerms.vue?vue&type=style&index=0&id=64a6af88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6af88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
